export default {
  path: '/products',
  name: 'products',
  component: () => import('../components/product/Layout'),
  redirect: { name: 'ProductList' },
  meta: {
    breadcrumb: 'qualitycheck.product.products',
  },
  children: [
    {
      name: 'ProductList',
      path: '',
      component: () => import('../views/product/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProductCreate',
      path: 'new',
      component: () => import('../views/product/Create'),
      meta: {
        breadcrumb: 'global.add',
      },

    },
    {
      name: 'ProductUpdate',
      path: ':id/edit',
      component: () => import('../views/product/Update'),
      meta: {
        breadcrumb: 'qualitycheck.product.product',
      },
    },
    {
      name: 'ProductShow',
      path: ':id',
      component: () => import('../views/product/Show'),
      meta: {
        breadcrumb: 'qualitycheck.product.product',
      },
    },
    {
      name: 'Product',
      path: ':parent',
      component: () => import('../components/productdata/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.datas',
      },
      children: [
        {
          name: 'ProductDataShow',
          path: ':id',
          component: () => import('../views/productdata/Show'),
          meta: {
            breadcrumb: 'qualitycheck.product.data',
          },
        },
        {
          name: 'ProductDataUpdate',
          path: ':id/edit',
          component: () => import('../views/productdata/Update'),
          meta: {
            breadcrumb: 'qualitycheck.product.data',
          },
        },
        {
          name: 'ProductDataCreate',
          path: 'new',
          component: () => import('../views/productdata/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
